import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, lastValueFrom, of, Subject, switchMap } from "rxjs";

//interfaces
import { ArticleInterface, OrderPreviewItemInterface } from "../interfaces";

//services
import { LocalArticleService, OrderService } from "../services";
import { HttpErrorResponse } from "@angular/common/http";
import { PaymentStatusEnum, ProductIdentifierEnum, ProductTypeEnum } from "../enums";

@Injectable({
    providedIn: 'root'
})
export class OrderHelper {

    private recalculateTrigger$ = new Subject<number | null>(); // Triggers recalculation
    public static checkoutStatus = new BehaviorSubject<PaymentStatusEnum | null>(null);


    constructor(
        private orderService: OrderService,
        private localArticleService: LocalArticleService
    ) {

        this.setupRecalculateListener();
    }

    async addToBasket(productId: string, productIdentifier: ProductIdentifierEnum, productType?: ProductTypeEnum, quantity?: number) {
        if (!quantity) quantity = 1;
        let order = OrderService.order.value;
        let orderItems = order ? order.itemList : [];
        let orderPreview = OrderService.orderPreview.getValue().order;
        const idx = orderItems.findIndex((element) => (element.article.id || element.article.barcode) == productId);
        if (idx !== -1 && productType !== ProductTypeEnum.quantityProduct) {
            const newItem = {
                article: {
                    id: productIdentifier == ProductIdentifierEnum.id ? productId : undefined,
                    barcode: productIdentifier == ProductIdentifierEnum.barcode ? productId : undefined,
                    quantity: orderItems[idx].article.quantity + quantity
                }
            }
            orderItems.splice(idx, 1);
            let orderPreviewItem = orderPreview!.itemList[idx];
            orderPreview!.itemList.splice(idx, 1);
            orderPreviewItem.quantity += quantity;
            orderPreview!.itemList.push(orderPreviewItem);
            OrderService.orderPreview.next({ new: orderPreview!.itemList.length - 1, order: orderPreview });
            orderItems.push(newItem);
        } else {
            const newItem = {
                article: {
                    id: productIdentifier == ProductIdentifierEnum.id ? productId : undefined,
                    barcode: productIdentifier == ProductIdentifierEnum.barcode ? productId : undefined,
                    quantity: quantity
                }
            }
            orderItems.push(newItem)
            if (productIdentifier == ProductIdentifierEnum.barcode) {
                try {
                    const res = await this.localArticleService.getLocalArticleByBarcode(productId);
                    if (res) {
                        const newOrderItem: OrderPreviewItemInterface = {
                            quantity: quantity,
                            productType: ProductTypeEnum.regularProduct,
                            barcode: res.barcode,
                            article: {
                                description: res.article_name,
                                baseUnitPrice: res.price,
                                discountedPrice: res.price,
                                singleDiscountedPrice: res.price,
                                minimum_age: null,
                                id: ''
                            }
                        }
                        console.log(newOrderItem);
                        if (orderPreview)
                            orderPreview!.itemList.push(newOrderItem)
                        else
                            orderPreview = { itemList: [newOrderItem], total: res.price, brutoTotal: res.price }
                        OrderService.orderPreview.next({ new: orderItems.length - 1, order: orderPreview });
                    }
                } catch (error) {
                    console.log(error)
                }
            }
            order!.itemList = orderItems
        }
    }

    async correctBasket(index: number, quantity: number = 1) {
        let order = OrderService.order.getValue();
        let orderItems = order ? order.itemList : [];
        let orderPreview = OrderService.orderPreview.getValue().order;
        if (quantity == 0) {
            orderItems.splice(index, 1);
            orderPreview!.itemList.splice(index, 1);
        } else {
            orderItems[index].article.quantity = quantity;
            orderPreview!.itemList[index].quantity = quantity;
        }
        order!.itemList = orderItems
        OrderService.order.next(order);
        OrderService.orderPreview.next({ new: null, order: orderPreview });
    }

    private setupRecalculateListener() {
        this.recalculateTrigger$
            .pipe(
                switchMap((index) =>
                    this.orderService.calculateOrder().pipe(
                        catchError((error) => {
                            console.log(error);
                            OrderService.errorMessage.next(error as HttpErrorResponse);
                            if ((error as HttpErrorResponse).status === 422) {
                                let order = OrderService.order.getValue();
                                const idx = order!.itemList.findIndex((element) => element.article.barcode! == (error as HttpErrorResponse).error.barcode);
                                order!.itemList.splice(idx, 1);
                                OrderService.order.next(order);
                                this.recalculateOrder(index);
                            }
                            OrderService.loading.next(false);
                            return of(null); // Prevent errors from breaking the stream
                        })
                    )
                )
            )
            .subscribe((res) => {
                if (res) {
                    let index = (OrderService.order.value?.itemList.length || 1) - 1;
                    OrderService.orderPreview.next({ new: index, order: res });
                } else {
                    let orderPreview = OrderService.orderPreview.getValue().order;
                    orderPreview!.itemList = [];
                    orderPreview!.brutoTotal = 0;
                    orderPreview!.total = 0;
                    orderPreview!.discounts = [];
                    OrderService.orderPreview.next({ new: 1, order: orderPreview });
                }
                OrderService.loading.next(false);
            });
    }

    recalculateOrder(index: number | null = null) {
        OrderService.loading.next(true);
        let order = OrderService.order.getValue();
        if (order?.itemList.length) {
            this.recalculateTrigger$.next(index);
        } else {
            let orderPreview = OrderService.orderPreview.getValue().order;
            orderPreview = { itemList: [], total: 0, brutoTotal: 0 }
            OrderService.orderPreview.next({ new: null, order: orderPreview });
            OrderService.loading.next(false);
        }
    }



    calculateSum() {
        let total = 0;
        let saved = 0;
        let employee = 0;
        let subtotal = 0;
        let order = OrderService.orderPreview.getValue().order;
        if (order) {
            order.itemList.forEach(element => {
                total += element.article.discountedPrice;
                saved += (Number(element.article.baseUnitPrice) - element.article.singleDiscountedPrice) * element.quantity;
                subtotal += element.article.baseUnitPrice * element.quantity;
            });
            if (order.discounts)
                employee += order.discounts[0].discount.value * -1;
        }
        return { total: total, saved: saved, employee: employee, subtotal: subtotal };
    }
}